import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function Hero() {
  return (
    <section className="hero">
      <div className="auto__container">
        <div className="hero__inner">
          <motion.div
            animate={{
              scale: [0, 1.1, 1],
              opacity: [0, 1],
            }}
            transition={{ duration: 0.6 }}
          >
            {/* <div className="hero__inner-top">
              <div className="hero__inner-logo">
                <img src={process.env.PUBLIC_URL + "/images/logo.png"} alt="" />
              </div>
              <h1>
                LEADERSHIP <br />
                SUMMIT
                <span>2024</span>
              </h1>
            </div> */}
            <div className="header-logo">
              <img
                className="img-fluid"
                src={process.env.PUBLIC_URL + "/images/header.png"}
                alt="Zip Recruiter Leadership Summit 2026"
              />
            </div>
          </motion.div>
          <motion.div
            animate={{
              x: [-70, 0],
              opacity: [0, 1],
            }}
            transition={{ duration: 0.6 }}
          >
            <div className="hero__inner-text">
              <h4>
                APRIL 15 – 17, 2026
                <span> | </span>
                CARNEROS RESORT
                <span> | </span>
                NAPA, CA
              </h4>
              {/* <p className="big">
                A premier thought-leadership and community building event hosted
                by recruitment leaders, for recruitment leaders.
              </p> */}
              <p>
                Join an exclusive group of Talent Acquisition leaders for a VIP experience.
              </p>
              <a
                href="https://cvent.me/k8rkmN"
                target="_blank"
                className="button primary"
              >
                REGISTER NOW
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
